module.exports = __webpack_public_path__ + "static/media/clok.0187cc43.png";